import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';
import { SIZES } from 'common/constants/sizes';

export const StyledExpandToggler = styled.div`
  color: ${getColor('shuttleGray')};
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`;

export const StyledTeamRowContainer = styled.div`
  padding: 0 0.5rem;
  & ${StyledExpandToggler} {
    margin-right: 0.8rem;
    font-size: ${SIZES['x-large']};
  }
  margin-left: ${({ treeLevel }) => `${treeLevel}%`};
`;

export const StyledTeamRow = styled.div`
  display: flex;
  align-items: center;
  padding: 0.3rem 0;
  & .team-name {
    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }
  }
  &.isSelected {
    font-weight: bold;
  }
`;

export const StyledTeamsPicker = styled.div`
  width: 100%;
  height: 100%;
  border: 1px solid ${getColor('catskillWhite')};
  & > .team-list {
    height: 90%;
    overflow-y: scroll;
  }
`;
